import { Field, formatDateTime, YesObject } from '@yes.technology/react-toolkit'

import { AllowedLocales } from 'shared/utils/date/formatDate'

export default function formatTaskCardFieldValue({
  value,
  field,
  language
}: {
  value?: YesObject[keyof YesObject] | null
  field?: Field
  language: string
}): string {
  if (value === null || value === undefined || value === '') {
    return ''
  }

  if (Array.isArray(value)) {
    return value
      .map((item) => item?.des ?? '')
      .filter(Boolean)
      .join(', ')
  }

  if (typeof value === 'object') {
    return (value as YesObject)?.des ?? ''
  }

  if (field?.type === 'DATETIME' && !Number.isNaN(Date.parse(String(value)))) {
    return formatDateTime(new Date(value as string), {
      locale: language as AllowedLocales,
      format: 'date-time',
      timezone: window.waTimezone
    })
  }

  return String(value)
}
